import { createRouter, createWebHistory } from "vue-router";
import { pinia } from "@/pinia";
import { useIsEditStore } from "@/stores/isEditStore";
import { useLoadingStore } from "@/stores/loadingStore";
import {
  canInternalUserLogin,
  getCurrent as getCurrentRoleType,
  isInternalUser,
} from "@/enums/roleType";

import DashboardView from "@/components/DashboardView";
import HomeEntryPage from "@/views/HomeEntryPage";
import LoginPage from "@/views/LoginPage";

import BasicBoard from "@/components/basic/BasicBoard";
const BasicCompany = () => import("@/components/basic/BasicCompany");
const BasicStoreAndTerminal = () =>
  import("@/components/basic/BasicStoreAndTerminal");
const BasicDepartment = () => import("@/components/basic/BasicDepartment");
const BasicEmployeeAndAuthority = () =>
  import("@/components/basic/BasicEmployeeAndAuthority");
const BasicFood = () => import("@/components/basic/BasicFood");
const FoodLabelData = () => import("@/components/datas/foods/FoodLabelData");
const BasicTaste = () => import("@/components/basic/BasicTaste");
const BasicCombo = () => import("@/components/basic/BasicCombo");
const BasicFunction = () => import("@/components/basic/BasicFunction");
const BasicPay = () => import("@/components/basic/BasicPay");
const BasicDirectoryKind = () =>
  import("@/components/basic/BasicDirectoryKind");
const BasicAccount = () => import("@/components/basic/BasicAccount");
const BasicPriceLabel = () => import("@/components/basic/BasicPriceLabel");
const BasicBrand = () => import("@/components/basic/BasicBrand");
const BasicPromotion = () => import("@/components/basic/BasicPromotion");
const BasicDay = () => import("@/components/basic/BasicDay");
const BasicPickup = () => import("@/components/basic/BasicPickup");
const BasicNationality = () => import("@/components/basic/BasicNationality");

import ReportBoard from "@/components/reports/ReportBoard";
const ReportSale = () => import("@/components/reports/sale/ReportSale");
const ReportClassSale = () =>
  import("@/components/reports/sale/ReportClassSale");
const ReportInvoice = () => import("@/components/reports/sale/ReportInvoice");
const ReportInvoicePrize = () =>
  import("@/components/reports/sale/ReportInvoicePrize");
const ReportEmployeeAnalysis = () =>
  import("@/components/reports/sale/ReportEmployeeAnalysis");
const ReportWorkRecord = () =>
  import("@/components/reports/sale/ReportWorkRecord");
const ReportSaler = () => import("@/components/reports/sale/ReportSaler");
const ReportPeople = () => import("@/components/reports/sale/ReportPeople");
const ReportCoupon = () => import("@/components/reports/sale/ReportCoupon");
const ReportSaleOrder = () =>
  import("@/components/reports/sale/ReportSaleOrder");
const ReportCollectionPayment = () =>
  import("@/components/reports/sale/ReportCollectionPayment");
const ReportSaleProfit = () =>
  import("@/components/reports/sale/ReportSaleProfit");
const ReportCreditCard = () =>
  import("@/components/reports/sale/ReportCreditCard");
const ReportBusinessRecord = () =>
  import("@/components/reports/sale/ReportBusinessRecord");
const ReportDeleteFood = () =>
  import("@/components/reports/sale/ReportDeleteFood");
const ReportKioskRecord = () =>
  import("@/components/reports/sale/ReportKioskRecord");
const ReportOrderFoodStatistic = () =>
  import("@/components/reports/sale/ReportOrderFoodStatistic");
const ReportFoodMajorKindStatistic = () =>
  import("@/components/reports/sale/ReportFoodMajorKindStatistic");
const ReportFoodKindStatistic = () =>
  import("@/components/reports/sale/ReportFoodKindStatistic");
const ReportFoodSaleStatistic = () =>
  import("@/components/reports/sale/ReportFoodSaleStatistic");
const ReportFoodDayStatistic = () =>
  import("@/components/reports/sale/ReportFoodDayStatistic");
const ReportFoodSale = () => import("@/components/reports/sale/ReportFoodSale");
const ReportFree = () => import("@/components/reports/sale/ReportFree");
const ReportTimeStatistic = () =>
  import("@/components/reports/sale/ReportTimeStatistic");
const ReportTasteStatistic = () =>
  import("@/components/reports/sale/ReportTasteStatistic");
const ReportFoodTasteStatistic = () =>
  import("@/components/reports/sale/ReportFoodTasteStatistic");
const ReportPay = () => import("@/components/reports/sale/ReportPay");
const ReportSalePay = () => import("@/components/reports/sale/ReportSalePay");

const ReportSupplier = () => import("@/components/reports/erp/ReportSupplier");
const ReportSupplierFoodSale = () =>
  import("@/components/reports/erp/ReportSupplierFoodSale");
const ReportSupplierFoodSaleOriginal = () =>
  import("@/components/reports/erp/ReportSupplierFoodSaleOriginal");
const ReportSupplierPurchaseOrder = () =>
  import("@/components/reports/erp/ReportSupplierPurchaseOrder");
const ReportFoodPurchaseOrder = () =>
  import("@/components/reports/erp/ReportFoodPurchaseOrder");
const ReportFoodPurchase = () =>
  import("@/components/reports/erp/ReportFoodPurchase");
const ReportERPSummary = () =>
  import("@/components/reports/erp/ReportERPSummary");
const ReportPurchaseOrder = () =>
  import("@/components/reports/erp/ReportPurchaseOrder");
const ReportPurchase = () => import("@/components/reports/erp/ReportPurchase");
const ReportPurchaseReturn = () =>
  import("@/components/reports/erp/ReportPurchaseReturn");
const ReportStockAdjust = () =>
  import("@/components/reports/erp/ReportStockAdjust");
const ReportStockAdjustDirectory = () =>
  import("@/components/reports/erp/ReportStockAdjustDirectory");
const ReportStockTransfers = () =>
  import("@/components/reports/erp/ReportStockTransfers");
const ReportInventory = () =>
  import("@/components/reports/erp/ReportInventory");
const ReportStock = () => import("@/components/reports/erp/ReportStock");
const ReportSafeQty = () => import("@/components/reports/erp/ReportSafeQty");
const ReportInventoryPAndL = () =>
  import("@/components/reports/erp/ReportInventoryPAndL");
const ReportFoodMovement = () =>
  import("@/components/reports/erp/ReportFoodMovement");
const ReportStockBatch = () =>
  import("@/components/reports/erp/ReportStockBatch");
const ReportStockBatchMovement = () =>
  import("@/components/reports/erp/ReportStockBatchMovement");
const ReportCombinationTrade = () =>
  import("@/components/reports/erp/ReportCombinationTrade");
const ReportSeparationTrade = () =>
  import("@/components/reports/erp/ReportSeparationTrade");
const ReportMonthlyCost = () =>
  import("@/components/reports/erp/ReportMonthlyCost");

const ReportCustomer = () =>
  import("@/components/reports/customer/ReportCustomer");
const ReportCustomerFoodSale = () =>
  import("@/components/reports/customer/ReportCustomerFoodSale");
const ReportCustomerSaleStatistic = () =>
  import("@/components/reports/customer/ReportCustomerSaleStatistic");
const ReportDeposit = () =>
  import("@/components/reports/customer/ReportDeposit");
const ReportIntegral = () =>
  import("@/components/reports/customer/ReportIntegral");
const ReportCustomerStock = () =>
  import("@/components/reports/customer/ReportCustomerStock");
const ReportCustomerStockMovement = () =>
  import("@/components/reports/customer/ReportCustomerStockMovement");
const ReportCustomerFree = () =>
  import("@/components/reports/customer/ReportCustomerFree");
const ReportPGTalkDeposit = () =>
  import("@/components/reports/customer/ReportPGTalkDeposit");
const ReportUploadLogs = () =>
  import("@/components/reports/others/ReportUploadLogs");
const ReportCreditCardCommunication = () =>
  import("@/components/reports/others/ReportCreditCardCommunication");
const ReportLoginLog = () =>
  import("@/components/reports/others/ReportLoginLog");
const CustomerLabelData = () =>
  import("@/components/datas/customers/CustomerLabelData");

import ERPBoard from "@/components/erps/ERPBoard";
const ERPOrders = () => import("@/components/erps/ERPOrders");
const ERPSales = () => import("@/components/erps/ERPSales");
const ERPPurchaseOrders = () => import("@/components/erps/ERPPurchaseOrders");
const ERPPurchases = () => import("@/components/erps/ERPPurchases");
const ERPStockAdjusts = () => import("@/components/erps/ERPStockAdjusts");
const ERPStockTransfers = () => import("@/components/erps/ERPStockTransfers");
const ERPInventorys = () => import("@/components/erps/ERPInventorys");
const ERPSafeQty = () => import("@/components/erps/ERPSafeQty");
const ERPWarehouse = () => import("@/components/erps/ERPWarehouse");
const ERPSupplier = () => import("@/components/erps/ERPSupplier");
const ERPCombination = () => import("@/components/erps/ERPCombination");
const ERPCombinationTrade = () =>
  import("@/components/erps/ERPCombinationTrade");
const ERPSeparationTrade = () => import("@/components/erps/ERPSeparationTrade");
const ERPOrderData = () => import("@/components/erps/OrderData");
const ERPSaleData = () => import("@/components/erps/SaleData");
const ERPPurchaseOrderData = () =>
  import("@/components/erps/PurchaseOrderData");
const ERPPurchaseData = () => import("@/components/erps/PurchaseData");
const ERPStockAdjustData = () => import("@/components/erps/StockAdjustData");
const ERPStockTransferData = () =>
  import("@/components/erps/StockTransferData");
const ERPInventoryData = () => import("@/components/erps/InventoryData");
const ERPInventoryMachine = () =>
  import("@/components/erps/ERPInventoryMachine");
const ERPCombinationData = () => import("@/components/erps/CombinationData");
const ERPCombinationTradeData = () =>
  import("@/components/erps/CombinationTradeData");
const ERPSeparationTradeData = () =>
  import("@/components/erps/SeparationTradeData");
const ERPMonthlyCostClosing = () =>
  import("@/components/erps/ERPMonthlyCostClosing");
const ERPLYStock = () => import("@/components/erps/ERPLYStock");
const ERPDWStock = () => import("@/components/erps/ERPDWStock");
const ERPRequisitions = () => import("@/components/erps/ERPRequisitions");
const ERPRequisitionData = () => import("@/components/erps/RequisitionData");

import AccountBoard from "@/components/accounts/AccountBoard";
const AccountReceivables = () =>
  import("@/components/accounts/AccountReceivables");
const AccountReceipts = () => import("@/components/accounts/AccountReceipts");
const ReceiptData = () => import("@/components/accounts/ReceiptData");
const AccountPayables = () => import("@/components/accounts/AccountPayables");
const AccountPayments = () => import("@/components/accounts/AccountPayments");
const PaymentData = () => import("@/components/accounts/PaymentData");

import OnlineOrderBoard from "@/components/onlineorders/OnlineOrderBoard";
const OnlineOrderUberEats = () =>
  import("@/components/onlineorders/OnlineOrderUberEats");
const KDS = () => import("@/components/onlineorders/KDS");
const OnlineOrderOcard = () =>
  import("@/components/onlineorders/OnlineOrderOcard");
const UberEatsToken = () => import("@/views/UberEatsToken");
const LineOA = () => import("@/components/onlineorders/LineOA");

import CustomerBoard from "@/components/customers/CustomerBoard";
const CustomerMain = () => import("@/components/customers/CustomerMain");
const MemberSetting = () => import("@/components/customers/MemberSetting");
const MemberWeb = () => import("@/components/customers/MemberWeb");
const EventSetting = () => import("@/components/customers/EventSetting");

import DownloadPage from "@/components/download/DownloadPage";
const ComponentDevelopmentPage = () =>
  import("@/views/ComponentDevelopmentPage");

const PrivacyPolicy = () => import("@/views/PrivacyPolicy");
const ManualPage = () => import("@/views/ManualPage");
const LegacyLogPage = () =>
  import("@/components/oldversion/logs/LegacyLogPage.vue");
const LegacyUsers = () =>
  import("@/components/oldversion/users/LegacyUsers.vue");
const LegacyLicenses = () =>
  import("@/components/oldversion/licenses/LegacyLicenses.vue");
const LegacyInvoicePrizes = () =>
  import("@/components/oldversion/invoiceprizes/LegacyInvoicePrizes.vue");
const LegacyUtaiForms = () =>
  import("@/components/oldversion/forms/LegacyUtaiForms.vue");
const LegacyUShowForms = () =>
  import("@/components/oldversion/forms/LegacyUShowForms.vue");
const LegacyPYReceivables = () =>
  import("@/components/oldversion/accounts/LegacyPYReceivables.vue");
const LegacyBusinesses = () =>
  import("@/components/oldversion/businesses/LegacyBusinesses.vue");
const LegacyDevices = () =>
  import("@/components/oldversion/businesses/LegacyDevices.vue");
const LegacyKDS = () =>
  import("@/components/oldversion/businesses/LegacyKDS.vue");

const hasManualPage = process.env.NODE_ENV === "development";
const hasComponentDevelopmentPage = process.env.NODE_ENV === "development";

// 原生 history API 若未保留 Vue Router state，重新整理後會造成下一次導航網址異常。
const historyState = window.history.state;
if (
  historyState &&
  (typeof historyState.current !== "string" ||
    typeof historyState.position !== "number")
) {
  window.history.replaceState(null, "", window.location.href);
}

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      component: DashboardView,
      meta: { requiresAuth: true },
      children: [
        {
          name: "Home",
          path: "/",
          component: HomeEntryPage,
        },
        {
          name: "OldVersionBusinesses",
          path: "/oldversion/businesses",
          component: LegacyBusinesses,
          meta: { internalOnly: true, allowedRoleTypes: [1, 2, 3, 5, 6] },
        },
        {
          name: "OldVersionKDS",
          path: "/oldversion/businesses/:id/kds",
          component: LegacyKDS,
          meta: { internalOnly: true, allowedRoleTypes: [1, 2, 3, 5, 6] },
        },
        {
          name: "OldVersionDevices",
          path: "/oldversion/businesses/:id/devices",
          component: LegacyDevices,
          meta: { internalOnly: true, allowedRoleTypes: [1, 2, 3, 5, 6] },
        },
        {
          name: "OldVersionErrorMessage",
          path: "/oldversion/logs/error-message",
          component: LegacyLogPage,
          props: { configKey: "error" },
          meta: { internalOnly: true, allowedRoleTypes: [2, 6] },
        },
        {
          name: "OldVersionThirdPartyLog",
          path: "/oldversion/logs/third-party",
          component: LegacyLogPage,
          props: { configKey: "thirdParty" },
          meta: { internalOnly: true, allowedRoleTypes: [2, 6] },
        },
        {
          name: "OldVersionSystemLog",
          path: "/oldversion/logs/system",
          component: LegacyLogPage,
          props: { configKey: "system" },
          meta: { internalOnly: true, allowedRoleTypes: [2, 6] },
        },
        {
          name: "OldVersionNotificationLog",
          path: "/oldversion/logs/notification",
          component: LegacyLogPage,
          props: { configKey: "notification" },
          meta: { internalOnly: true, allowedRoleTypes: [2, 6] },
        },
        {
          name: "OldVersionWebhookLog",
          path: "/oldversion/logs/webhook",
          component: LegacyLogPage,
          props: { configKey: "webhook" },
          meta: { internalOnly: true, allowedRoleTypes: [2, 6] },
        },
        {
          name: "OldVersionUsers",
          path: "/oldversion/users",
          component: LegacyUsers,
          meta: { internalOnly: true, allowedRoleTypes: [1, 2, 3, 5, 6] },
        },
        {
          name: "OldVersionInvoicePrizes",
          path: "/oldversion/invoice-prizes",
          component: LegacyInvoicePrizes,
          meta: { internalOnly: true, allowedRoleTypes: [1, 2, 3, 5, 6] },
        },
        {
          name: "OldVersionUtaiForms",
          path: "/oldversion/utai-forms",
          component: LegacyUtaiForms,
          meta: { internalOnly: true, allowedRoleTypes: [1, 2, 3, 5, 6] },
        },
        {
          name: "OldVersionUShowForms",
          path: "/oldversion/ushow-forms",
          component: LegacyUShowForms,
          meta: { internalOnly: true, allowedRoleTypes: [1, 2, 3, 5, 6] },
        },
        {
          name: "OldVersionLicenses",
          path: "/oldversion/licenses",
          component: LegacyLicenses,
          meta: { internalOnly: true, allowedRoleTypes: [1, 2, 3, 5, 6] },
        },
        {
          name: "OldVersionPYReceivables",
          path: "/oldversion/receivables",
          component: LegacyPYReceivables,
          meta: { internalOnly: true, allowedRoleTypes: [3] },
        },
        {
          path: "basic",
          component: BasicBoard,
          children: [
            {
              name: "Company",
              path: "/company",
              component: BasicCompany,
            },
            {
              name: "StoresAndTerminals",
              path: "/terminals",
              component: BasicStoreAndTerminal,
            },
            {
              name: "Departments",
              path: "/departments",
              component: BasicDepartment,
            },
            {
              name: "EmployeesAndAuthority",
              path: "/employees",
              component: BasicEmployeeAndAuthority,
            },
            {
              name: "Foods",
              path: "/products",
              component: BasicFood,
            },
            {
              name: "FoodLabels",
              path: "/products/labels",
              component: FoodLabelData,
            },
            {
              name: "TasteKinds",
              path: "/tastes",
              component: BasicTaste,
            },
            {
              name: "ComboKinds",
              path: "/bundles",
              component: BasicCombo,
            },
            {
              name: "Functions",
              path: "/functions",
              component: BasicFunction,
            },
            {
              name: "Pays",
              path: "/pays",
              component: BasicPay,
            },
            {
              name: "DirectoryKinds",
              path: "/directories",
              component: BasicDirectoryKind,
            },
            {
              name: "Accounts",
              path: "/accounts",
              component: BasicAccount,
            },
            {
              name: "PriceLabels",
              path: "/price-labels",
              component: BasicPriceLabel,
            },
            {
              name: "Brands",
              path: "/brands",
              component: BasicBrand,
            },
            {
              name: "Promotion",
              path: "/promotions",
              component: BasicPromotion,
            },
            {
              name: "Day",
              path: "/days",
              component: BasicDay,
            },
            {
              name: "Pickups",
              path: "/pickups",
              component: BasicPickup,
            },
            {
              name: "Nationality",
              path: "/nationality",
              component: BasicNationality,
            },
          ],
        },
        {
          path: "",
          component: ReportBoard,
          children: [
            {
              name: "ReportSale",
              path: "reports/sale",
              component: ReportSale,
            },
            {
              name: "ReportClassSale",
              path: "reports/class-sale",
              component: ReportClassSale,
            },
            {
              name: "ReportInvoice",
              path: "reports/invoice",
              component: ReportInvoice,
            },
            {
              name: "ReportInvoicePrize",
              path: "reports/invoice-prize",
              component: ReportInvoicePrize,
            },
            {
              name: "ReportEmployeeAnalysis",
              path: "reports/employee-analysis",
              component: ReportEmployeeAnalysis,
            },
            {
              name: "ReportWorkRecord",
              path: "reports/work-record",
              component: ReportWorkRecord,
            },
            {
              name: "ReportSaler",
              path: "reports/saler",
              component: ReportSaler,
            },
            {
              name: "ReportPeople",
              path: "reports/people",
              component: ReportPeople,
            },
            {
              name: "ReportCoupon",
              path: "reports/coupon",
              component: ReportCoupon,
            },
            {
              name: "ReportSaleOrder",
              path: "reports/order",
              component: ReportSaleOrder,
            },
            {
              name: "ReportCollectionPayment",
              path: "reports/collection-payment",
              component: ReportCollectionPayment,
            },
            {
              name: "ReportSaleProfit",
              path: "reports/sale-profit",
              component: ReportSaleProfit,
            },
            {
              name: "ReportCreditCard",
              path: "reports/credit-card",
              component: ReportCreditCard,
            },
            {
              name: "ReportBusinessRecord",
              path: "reports/business-record",
              component: ReportBusinessRecord,
            },
            {
              name: "ReportDeleteFood",
              path: "reports/delete-food",
              component: ReportDeleteFood,
            },
            {
              name: "ReportKioskRecord",
              path: "reports/kiosk-transaction-logs",
              component: ReportKioskRecord,
            },
            {
              name: "ReportOrderFoodStatistic",
              path: "reports/order-product-statistic",
              component: ReportOrderFoodStatistic,
            },
            {
              name: "ReportFoodMajorKindStatistic",
              path: "reports/product-major-category-statistic",
              component: ReportFoodMajorKindStatistic,
            },
            {
              name: "ReportFoodKindStatistic",
              path: "reports/product-category-statistic",
              component: ReportFoodKindStatistic,
            },
            {
              name: "ReportFoodSaleStatistic",
              path: "reports/product-sale-statistic",
              component: ReportFoodSaleStatistic,
            },
            {
              name: "ReportFoodDayStatistic",
              path: "reports/product-day-statistic",
              component: ReportFoodDayStatistic,
            },
            {
              name: "ReportFoodSale",
              path: "reports/product-sale",
              component: ReportFoodSale,
            },
            {
              name: "ReportFree",
              path: "reports/free",
              component: ReportFree,
            },
            {
              name: "ReportTimeStatistic",
              path: "reports/time-statistic",
              component: ReportTimeStatistic,
            },
            {
              name: "ReportTasteStatistic",
              path: "reports/taste-statistic",
              component: ReportTasteStatistic,
            },
            {
              name: "ReportFoodTasteStatistic",
              path: "reports/food-taste-statistic",
              component: ReportFoodTasteStatistic,
            },
            {
              name: "ReportPay",
              path: "reports/pay",
              component: ReportPay,
            },
            {
              name: "ReportSalePay",
              path: "reports/sale-pay",
              component: ReportSalePay,
            },
            {
              name: "ReportSupplier",
              path: "reports/supplier",
              component: ReportSupplier,
            },
            {
              name: "ReportSupplierFoodSale",
              path: "reports/supplier-product-sale",
              component: ReportSupplierFoodSale,
            },
            {
              name: "ReportSupplierFoodSaleOriginal",
              path: "reports/supplier-product-sale-original",
              component: ReportSupplierFoodSaleOriginal,
            },
            {
              name: "ReportSupplierPurchaseOrder",
              path: "reports/supplier-purchase-order",
              component: ReportSupplierPurchaseOrder,
            },
            {
              name: "ReportFoodPurchaseOrder",
              path: "reports/product-purchase-order",
              component: ReportFoodPurchaseOrder,
            },
            {
              name: "ReportFoodPurchase",
              path: "reports/product-purchase",
              component: ReportFoodPurchase,
            },
            {
              name: "ReportERPSummary",
              path: "reports/erp-summary",
              component: ReportERPSummary,
            },
            {
              name: "ReportPurchaseOrder",
              path: "reports/purchase-order",
              component: ReportPurchaseOrder,
            },
            {
              name: "ReportPurchase",
              path: "reports/purchase",
              component: ReportPurchase,
            },
            {
              name: "ReportPurchaseReturn",
              path: "reports/purchase-return",
              component: ReportPurchaseReturn,
            },
            {
              name: "ReportStockAdjust",
              path: "reports/stock-adjust",
              component: ReportStockAdjust,
            },
            {
              name: "ReportStockAdjustDirectory",
              path: "reports/stock-adjust-directory",
              component: ReportStockAdjustDirectory,
            },
            {
              name: "ReportStockTransfers",
              path: "reports/stock-transfers",
              component: ReportStockTransfers,
            },
            {
              name: "ReportInventory",
              path: "reports/inventory",
              component: ReportInventory,
            },
            {
              name: "ReportStock",
              path: "reports/stock",
              component: ReportStock,
            },
            {
              name: "ReportSafeQty",
              path: "reports/safe-qty",
              component: ReportSafeQty,
            },
            {
              name: "ReportInventoryPAndL",
              path: "reports/inventorypandl",
              component: ReportInventoryPAndL,
            },
            {
              name: "ReportFoodMovement",
              path: "reports/prodcut-movement",
              component: ReportFoodMovement,
            },
            {
              name: "ReportStockBatch",
              path: "reports/stockbatch",
              component: ReportStockBatch,
            },
            {
              name: "ReportStockBatchMovement",
              path: "reports/stockbatch-movement",
              component: ReportStockBatchMovement,
            },
            {
              name: "ReportCombinationTrade",
              path: "reports/combination-trade",
              component: ReportCombinationTrade,
            },
            {
              name: "ReportSeparationTrade",
              path: "reports/separation-trade",
              component: ReportSeparationTrade,
            },
            {
              name: "ReportMonthlyCost",
              path: "reports/monthly-cost",
              component: ReportMonthlyCost,
            },
            {
              name: "ReportCustomer",
              path: "reports/customer",
              component: ReportCustomer,
            },
            {
              name: "ReportCustomerFoodSale",
              path: "reports/customer-product-sale",
              component: ReportCustomerFoodSale,
            },
            {
              name: "ReportCustomerSaleStatistic",
              path: "reports/customer-sale-statistic",
              component: ReportCustomerSaleStatistic,
            },
            {
              name: "ReportDeposit",
              path: "reports/deposit",
              component: ReportDeposit,
            },
            {
              name: "ReportIntegral",
              path: "reports/integral",
              component: ReportIntegral,
            },
            {
              name: "ReportCustomerStock",
              path: "reports/customer-stock",
              component: ReportCustomerStock,
            },
            {
              name: "ReportCustomerStockMovement",
              path: "reports/customer-stock-movement",
              component: ReportCustomerStockMovement,
            },
            {
              name: "ReportCustomerFree",
              path: "reports/customer-free",
              component: ReportCustomerFree,
            },
            {
              name: "ReportPGTalkDeposit",
              path: "reports/pgtalk-deposit",
              component: ReportPGTalkDeposit,
            },
            {
              name: "ReportUploadLogs",
              path: "reports/upload-logs",
              component: ReportUploadLogs,
            },
            {
              name: "ReportCreditCardCommunication",
              path: "reports/credit-card-communication",
              component: ReportCreditCardCommunication,
            },
            {
              name: "ReportLoginLog",
              path: "reports/login-log",
              component: ReportLoginLog,
            },
          ],
        },
        {
          path: "",
          component: CustomerBoard,
          children: [
            {
              name: "Customers",
              path: "customers",
              component: CustomerMain,
            },
            {
              name: "MemberSetting",
              path: "member-setting",
              component: MemberSetting,
            },
            {
              name: "MemberWeb",
              path: "member-web",
              component: MemberWeb,
            },
            {
              name: "EventSetting",
              path: "event-setting",
              component: EventSetting,
            },
            {
              name: "CustomerLabelData",
              path: "/customers/labels",
              component: CustomerLabelData,
            },
          ],
        },
        {
          path: "",
          component: ERPBoard,
          children: [
            {
              name: "Warehouses",
              path: "erp/warehouses",
              component: ERPWarehouse,
            },
            {
              name: "Suppliers",
              path: "erp/suppliers",
              component: ERPSupplier,
            },
            {
              name: "SafeQty",
              path: "erp/safeqty",
              component: ERPSafeQty,
            },
            {
              name: "Orders",
              path: "erp/orders",
              component: ERPOrders,
            },
            {
              name: "OrderAdd",
              path: "erp/order-data",
              component: ERPOrderData,
            },
            {
              name: "OrderView",
              path: "erp/order-data/:id/view",
              component: ERPOrderData,
            },
            {
              name: "OrderEdit",
              path: "erp/order-data/:id",
              component: ERPOrderData,
            },
            {
              name: "Sals",
              path: "erp/sales",
              component: ERPSales,
            },
            {
              name: "SalAdd",
              path: "erp/sale-data",
              component: ERPSaleData,
            },
            {
              name: "SalView",
              path: "erp/sale-data/:id/view",
              component: ERPSaleData,
            },
            {
              name: "SalEdit",
              path: "erp/sale-data/:id",
              component: ERPSaleData,
            },
            {
              name: "SalReturns",
              path: "erp/sale-returns",
              component: ERPSales,
            },
            {
              name: "SalReturnAdd",
              path: "erp/sale-return-data",
              component: ERPSaleData,
            },
            {
              name: "SalReturnView",
              path: "erp/sale-return-data/:id/view",
              component: ERPSaleData,
            },
            {
              name: "SalReturnEdit",
              path: "erp/sale-return-data/:id",
              component: ERPSaleData,
            },
            {
              name: "Requisitions",
              path: "erp/requisitions",
              component: ERPRequisitions,
            },
            {
              name: "RequisitionAdd",
              path: "erp/requisition-data",
              component: ERPRequisitionData,
            },
            {
              name: "RequisitionEdit",
              path: "erp/requisition-data/:id",
              component: ERPRequisitionData,
            },
            {
              name: "RequisitionView",
              path: "erp/requisition-data/:id/view",
              component: ERPRequisitionData,
            },
            {
              name: "PurchaseOrders",
              path: "erp/purchase-orders",
              component: ERPPurchaseOrders,
            },
            {
              name: "PurchaseOrderAdd",
              path: "erp/purchase-order-data",
              component: ERPPurchaseOrderData,
            },
            {
              name: "PurchaseOrderView",
              path: "erp/purchase-order-data/:id/view",
              component: ERPPurchaseOrderData,
            },
            {
              name: "PurchaseOrderEdit",
              path: "erp/purchase-order-data/:id",
              component: ERPPurchaseOrderData,
            },
            {
              name: "PurchaseOrderTurn",
              path: "erp/purchase-orders/:orderid/purchase-data",
              component: ERPPurchaseData,
            },
            {
              name: "Purchases",
              path: "erp/purchases",
              component: ERPPurchases,
            },
            {
              name: "PurchaseAdd",
              path: "erp/purchase-data",
              component: ERPPurchaseData,
            },
            {
              name: "PurchaseView",
              path: "erp/purchase-data/:id/view",
              component: ERPPurchaseData,
            },
            {
              name: "PurchaseEdit",
              path: "erp/purchase-data/:id",
              component: ERPPurchaseData,
            },
            {
              name: "PurchaseSpecification",
              path: "erp/purchase-data/specification/:foodid",
              component: ERPPurchaseData,
            },
            {
              name: "PurchaseReturns",
              path: "erp/purchase-returns",
              component: ERPPurchases,
            },
            {
              name: "PurchaseReturnAdd",
              path: "erp/purchase-return-data",
              component: ERPPurchaseData,
            },
            {
              name: "PurchaseReturnView",
              path: "erp/purchase-return-data/:id/view",
              component: ERPPurchaseData,
            },
            {
              name: "PurchaseReturnEdit",
              path: "erp/purchase-return-data/:id",
              component: ERPPurchaseData,
            },
            {
              name: "StockAdjusts",
              path: "erp/stock-adjusts",
              component: ERPStockAdjusts,
            },
            {
              name: "StockAdjustAdd",
              path: "erp/stock-adjust-data",
              component: ERPStockAdjustData,
            },
            {
              name: "StockAdjustView",
              path: "erp/stock-adjust-data/:id/view",
              component: ERPStockAdjustData,
            },
            {
              name: "StockAdjustEdit",
              path: "erp/stock-adjust-data/:id",
              component: ERPStockAdjustData,
            },
            {
              name: "StockTransfers",
              path: "erp/stock-transfers",
              component: ERPStockTransfers,
            },
            {
              name: "StockTransferAdd",
              path: "erp/stock-transfer-data",
              component: ERPStockTransferData,
            },
            {
              name: "StockTransferView",
              path: "erp/stock-transfer-data/:id/view",
              component: ERPStockTransferData,
            },
            {
              name: "StockTransferEdit",
              path: "erp/stock-transfer-data/:id",
              component: ERPStockTransferData,
            },
            {
              name: "StockTransferCheck",
              path: "erp/stock-transfer-check/:id",
              component: ERPStockTransferData,
            },
            {
              name: "Inventorys",
              path: "erp/inventorys",
              component: ERPInventorys,
            },
            {
              name: "InventoryAdd",
              path: "erp/inventory-data",
              component: ERPInventoryData,
            },
            {
              name: "InventoryView",
              path: "erp/inventory-data/:id/view",
              component: ERPInventoryData,
            },
            {
              name: "InventoryEdit",
              path: "erp/inventory-data/:id",
              component: ERPInventoryData,
            },
            {
              name: "InventoryMachine",
              path: "erp/inventory-machine",
              component: ERPInventoryMachine,
            },
            {
              name: "Combinations",
              path: "erp/combinations",
              component: ERPCombination,
            },
            {
              name: "CombinationEdit",
              path: "erp/combination-data/:id",
              component: ERPCombinationData,
            },
            {
              name: "CombinationTrades",
              path: "erp/combination-trades",
              component: ERPCombinationTrade,
            },
            {
              name: "CombinationTradeAdd",
              path: "erp/combination-trade-data",
              component: ERPCombinationTradeData,
            },
            {
              name: "CombinationTradeView",
              path: "erp/combination-trade-data/:id/view",
              component: ERPCombinationTradeData,
            },
            {
              name: "CombinationTradeReturn",
              path: "erp/combination-trade/:id/separation",
              component: ERPSeparationTradeData,
            },
            {
              name: "SeparationTrades",
              path: "erp/separation-trades",
              component: ERPSeparationTrade,
            },
            {
              name: "SeparationTradeAdd",
              path: "erp/separation-trade-data",
              component: ERPSeparationTradeData,
            },
            {
              name: "SeparationTradeView",
              path: "erp/separation-trade/:id/view",
              component: ERPSeparationTradeData,
            },
            {
              name: "SeparationTradeEdit",
              path: "erp/separation-trade/:id",
              component: ERPSeparationTradeData,
            },
            {
              name: "MonthlyCostClosing",
              path: "erp/monthly-cost-closing",
              component: ERPMonthlyCostClosing,
            },
            {
              name: "LYStock",
              path: "erp/lystock",
              component: ERPLYStock,
            },
            {
              name: "DWStock",
              path: "erp/dwstock",
              component: ERPDWStock,
            },
          ],
        },
        {
          path: "",
          component: AccountBoard,
          children: [
            {
              name: "Receivables",
              path: "finance/receivables",
              component: AccountReceivables,
            },
            {
              name: "Receipts",
              path: "finance/receipts",
              component: AccountReceipts,
            },
            {
              name: "ReceiptAdd",
              path: "finance/receipt-data",
              component: ReceiptData,
            },
            {
              name: "ReceiptView",
              path: "finance/receipt-data/:id/view",
              component: ReceiptData,
            },
            {
              name: "ReceiptEdit",
              path: "finance/receipt-data/:id",
              component: ReceiptData,
            },
            {
              name: "Payables",
              path: "finance/payables",
              component: AccountPayables,
            },
            {
              name: "Payments",
              path: "finance/payments",
              component: AccountPayments,
            },
            {
              name: "PaymentAdd",
              path: "finance/payment-data",
              component: PaymentData,
            },
            {
              name: "PaymentView",
              path: "accounts/payment-data/:id/view",
              component: PaymentData,
            },
            {
              name: "PaymentEdit",
              path: "accounts/payment-data/:id",
              component: PaymentData,
            },
          ],
        },
        {
          path: "",
          component: OnlineOrderBoard,
          children: [
            {
              name: "UberEats",
              path: "online-order/uber-eats",
              component: OnlineOrderUberEats,
            },
            {
              name: "KDS",
              path: "online-order/kds",
              component: KDS,
            },
            {
              name: "Ocard",
              path: "online-order/ocard",
              component: OnlineOrderOcard,
            },
            {
              name: "LineOA",
              path: "line-oa",
              component: LineOA,
            },
          ],
        },
        {
          name: "Download",
          path: "download",
          component: DownloadPage,
        },
        ...(hasManualPage
          ? [
              {
                name: "Manual",
                path: "manual",
                component: ManualPage,
              },
            ]
          : []),
        ...(hasComponentDevelopmentPage
          ? [
              {
                name: "ComponentDevelopment",
                path: "component-development",
                component: ComponentDevelopmentPage,
              },
            ]
          : []),
      ],
    },
    {
      name: "Login",
      path: "/login",
      component: LoginPage,
    },
    {
      name: "UberEatsToken",
      path: "/ubereats/accesstoken",
      component: UberEatsToken,
    },
    {
      name: "PrivacyPolicy",
      path: "/privacy-policy",
      component: PrivacyPolicy,
    },
  ],
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((route) => route.meta.requiresAuth);
  if (requiresAuth && !window.localStorage.getItem("token")) {
    return next({ name: "Login" });
  }

  const roleType = getCurrentRoleType();
  if (requiresAuth && roleType === null) {
    window.localStorage.clear();
    return next({ name: "Login" });
  }
  if (requiresAuth && isInternalUser(roleType) && !canInternalUserLogin()) {
    window.localStorage.clear();
    return next({ name: "Login" });
  }
  if (to.meta.internalOnly) {
    const allowedRoleTypes = to.meta.allowedRoleTypes || [];
    if (roleType === 0 || !allowedRoleTypes.includes(roleType)) {
      return next({ name: "Home" });
    }
  }
  const isEditStore = useIsEditStore(pinia);
  if (isEditStore.isEdit) {
    const answer = window.confirm("資料尚未儲存，確定要離開嗎 ?");
    if (!answer) {
      return next(false);
    }
  }
  useLoadingStore(pinia).startRouteNavigation();
  next();
});

router.afterEach(() => {
  const isEditStore = useIsEditStore(pinia);
  isEditStore.isEdit = false;
  useLoadingStore(pinia).finishRouteNavigation();
});

router.onError(() => {
  useLoadingStore(pinia).finishRouteNavigation();
});

export default router;
